var map = {
	"./Stretcher.svg": "fbe2",
	"./Walk.svg": "3ea5",
	"./WheelChair.svg": "778a",
	"./anonymous-avatar.png": "ca10",
	"./bathroom-scale.png": "f353",
	"./bg-flow-mobile.png": "08b6",
	"./credit.png": "fac6",
	"./doc.png": "fa64",
	"./drug.png": "eea6",
	"./examination.png": "0432",
	"./favorite.svg": "8918",
	"./favoriteGray.svg": "9bda",
	"./logo.svg": "1ae4",
	"./medicine.png": "9e62",
	"./money.png": "9443",
	"./new-hn.png": "f63e",
	"./nurse.png": "65ed",
	"./opd.png": "c061",
	"./payment.png": "c94f",
	"./qr-code.png": "3ac7",
	"./scan-qr-code-success": "e7cb",
	"./scan-qr-code-success.json": "e7cb",
	"./screen.png": "cd6c",
	"./sofa.png": "d329",
	"./user-edit.png": "0d0d",
	"./young-man-avatar.png": "83ec",
	"./young-woman-avatar.png": "4e3b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";